import React from 'react'
import { Link } from 'react-router-dom'
import MagazaButonlari from './magaza-butonlari'
import '../assets/css/site-yesil.css'

export default function FooterV2() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="ht-foot">
            <div className="ht-wrap ht-foot-main">
                <div className="ht-foot-brand">
                    <img src="/assets/images/logo.png" alt="HatimTakip Logo" />
                    <p>
                        Kur'an-ı Kerim ve Risale-i Nur Külliyatı'nı bireysel veya grup halinde
                        okuyarak ilerlemenizi takip etmenizi sağlayan modern mobil uygulama.
                    </p>
                </div>
                <div>
                    <h3>Hızlı Linkler</h3>
                    <ul className="ht-foot-links">
                        <li><Link to="/" aria-label="Ana Sayfa">Ana Sayfa</Link></li>
                        <li><Link to="/privacy-policy" aria-label="Gizlilik Politikası">Gizlilik Politikası</Link></li>
                        <li><Link to="/terms-of-service" aria-label="Kullanım Koşulları">Kullanım Koşulları</Link></li>
                        <li><Link to="/support" aria-label="Destek">Destek</Link></li>
                    </ul>
                </div>
                <div>
                    <h3>Yardım & Destek</h3>
                    <ul className="ht-foot-links">
                        <li><Link to="/permissions" aria-label="İzinler">İzinler</Link></li>
                        <li><Link to="/account-deletion" aria-label="Hesap Silme">Hesap Silme</Link></li>
                        <li><Link to="/licenses" aria-label="Lisanslar">Lisanslar</Link></li>
                        <li><Link to="/support" aria-label="İletişim">İletişim</Link></li>
                    </ul>
                </div>
                <div>
                    <h3>Hemen Deneyin</h3>
                    <MagazaButonlari ustYazi="Şuradan İndir" />
                </div>
            </div>
            <div className="ht-foot-bottom">
                Copyright &copy; {currentYear} HatimTakip. Tüm hakları saklıdır.
            </div>
        </footer>
    );
}
